import { Box, Flex, Heading, Image, Spacer, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import Link from 'next/link';
import { useAppDataContext } from 'misc/appDataCtxt';
import { AppDataActions } from 'misc/enums';
import { useMatomo } from '@datapunt/matomo-tracker-react';

interface Props {
  id: number;
  image: string;
  alt?: string;
  name: string;
  detail: string;
  price: number;
  url: string;
}

export const MenuItem: FC<Props> = ({ id, image, alt: imageAlt, name, detail, price, url }) => {
  const { trackEvent } = useMatomo();
  const { dispatch } = useAppDataContext();

  const selectPizza = () => {
    trackEvent({ category: 'Navigation', action: 'show-pizza' });
    dispatch({
      type: AppDataActions.updateCurrentItem,
      value: {
        currentItem: {
          id,
          name,
        },
      },
    });
  };

  return (
    <Link href={url} passHref>
      <Flex
        direction={'row'}
        border={'1px'}
        borderRadius={4}
        borderColor={'gray.100'}
        justifyContent={'space-between'}
        shadow={'md'}
        mb={4}
        w="100%"
        cursor={'pointer'}
        onClick={selectPizza}
      >
        <Box maxW={'40%'} height={'auto'}>
          <Image src={image} alt={imageAlt || name} roundedLeft={4} shadow={'md'} />
        </Box>
        <Flex p={4} direction="column" gap={2} justifyContent="space-between">
          <Heading as="h2" size="md">
            {name}
          </Heading>
          <Text>{detail}</Text>
          <Spacer />
          <Text color={'blackAlpha.500'}>{price} €</Text>
        </Flex>
      </Flex>
    </Link>
  );
};
